import { CheckCircle } from '@phosphor-icons/react';
import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

const TRUST_POINTS: readonly string[] = [
  'Cahier des charges structuré par IA',
  'Devis comparables ligne à ligne',
  'Suivi tâche par tâche, tracé',
];

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});

function AuthLayout(): React.ReactElement {
  return (
    <div className="bg-background grid h-dvh grid-cols-1 overflow-hidden lg:grid-cols-2">
      <div className="relative isolate overflow-hidden">
        <div
          aria-hidden
          className="bg-paper pointer-events-none absolute inset-0 -z-10 opacity-50"
        />
        <div className="h-full overflow-y-auto">
          <div className="mx-auto flex min-h-full w-full max-w-2xl flex-col justify-center px-5 py-12 sm:px-6">
            <Link
              to="/"
              aria-label="Devizy — accueil"
              className="font-display text-primary mx-auto inline-flex text-2xl font-semibold tracking-tight"
            >
              Devizy
            </Link>
            <div className="mt-10 w-full">
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <aside
        aria-hidden
        className="relative hidden overflow-hidden bg-[hsl(var(--brand-navy))] text-white lg:flex lg:flex-col lg:p-14 xl:p-16"
      >
        <div
          aria-hidden
          className="bg-paper pointer-events-none absolute inset-0 -z-10 opacity-30"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(55%_45%_at_80%_15%,hsl(var(--brand-green)/0.22),transparent_60%),radial-gradient(46%_42%_at_15%_90%,hsl(0_0%_100%/0.07),transparent_70%)]"
        />
        <span className="font-display self-start text-2xl font-semibold tracking-tight">
          Devizy
        </span>
        <div className="flex max-w-md flex-1 flex-col justify-center">
          <p className="mb-4 inline-flex items-center gap-2 text-xs font-medium tracking-wider text-[hsl(var(--brand-peach))] uppercase">
            <span aria-hidden className="h-1 w-1 rounded-full bg-[hsl(var(--brand-peach))]" />
            Spécialisé IT · Tech · Digital
          </p>
          <p className="font-display text-3xl leading-[1.15] tracking-tight xl:text-4xl">
            Le brief en mots, le projet en tâches.
          </p>
          <ul className="mt-8 flex flex-col gap-3.5">
            {TRUST_POINTS.map((point) => (
              <li key={point} className="flex items-center gap-3 text-sm text-white/90">
                <CheckCircle
                  weight="fill"
                  className="size-5 shrink-0 text-[hsl(var(--brand-peach))]"
                />
                {point}
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  );
}
